<div class=" mt-4" *ngIf="PayoutTour">
  <section class="my-4">
    <div class="scrollmenu">
      <a [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>
       <!-- <a [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a> -->
      <a [routerLinkActive]="" class="active menu" [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a>
        <a [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a>

     <!-- <a [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
      <a [routerLink]="['/PayOut/PayOutTransactions']">PayOut Transaction</a>
      <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a>
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
      <a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a>
      <!-- <a  [routerLink]="['/PayOut/PayoutPostback']">PayOut PostBack Url</a> -->
      <!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a> 
      <a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a>-->
    </div>
  </section>
  <section>
    <div class="col-md-12 pb-4">

      <div class="row" *ngIf="Workclose">
        <div class="col-md-12 p-0">

          <div class="row">
            <div class="col-lg-12">
              <div class="card-1 px-1 p-4">
                <div class="col-md-12 pb-3">
                  <div class="d-inline">
                    <!-- <label class="gary-t  l-h21 font-14 mb-0">CurrentBalance: <b
                        class="robot">{{accountbal.CurrentBalance | currency:"₹"}}</b> </label> -->
                  </div>
                  <a class="d-inline float-right font-16 blue1-t mt-1" (click)="close()"
                    style="margin-top:-25px;color: #442B66;">Close</a>
                </div>
                <div class="col-md-12 pb-2">
                  <h3 class="font-26 gary-t text-center font600">How it Works</h3>
                </div>
                <div class="row hw-bg">
                  <div class="col-md-4">
                    <div class="text-center">
                      <img src="assets/img/new/view-all-icon.png">

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="text-center">
                      <img src="assets/img/new/create-user.png">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="text-center">
                      <img src="assets/img/new/transfer-icon.png">
                    </div>
                  </div>
                </div>
                <div class="row text-center">

                  <div class="col-md-4">
                    <div class="py-3">

                      <p class="lite-gray-t">Go to Payout Contact under Manage Payouts to view all your Payout contact
                      </p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="py-3">

                      <p class="lite-gray-t">You can view, edit, delete, add beneficiary & create transaction under
                        manage Payout contact</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="py-3">

                      <p class="lite-gray-t">Displays all the records of Payout transactions</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- end card -->
          </div>
        </div>

      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <a href="" class="back-tour mr-3" type="a"   data-bs-toggle="modal" data-bs-target="#exampleModalCenter"> <i class="fa fa-info-circle" aria-hidden="true"></i> &nbsp; Need Assistance? Let's Explore <i
            class="far fa-lightbulb"></i></a>
          <button class="dash-btns mr-3" type="button" id="NewPrepaidCard" [routerLink]="['/PayOut/NewPayOutContact']"
            color="primary" matTooltip="New PrepaidCard" *ngIf="newpayout"> New Contact</button>

          <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-bs-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a id="btnExportBatch" (click)="readAndExportTransactionData()">Excel</a></li>
            </ul>
          </div>



          <!-- <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"> <i class="filter-icon">&nbsp;</i> Filter</button> -->
          
          <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"> <i class="fa fa-filter" aria-hidden="true"></i> &nbsp; Filter</button>


        </div>
      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 10 Records. For more details please click
          onFilter</small>
      </div>
    </div>

    <div class="row  my-4" *ngIf="filtering">
      <div class="col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>
          <div class="col-md-12">
            <!-- filtering starts -->
            <form>
              <div class="row m-0">
                <div class="col-md-3 mt-4">
                  
                  <div class="form-group">
                    <label class="customlabel">Date</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="Range" id="daterange" placeholder="Select date" [formControl]="daterange" required
                      (ngModelChange)="checkRangeType()">
                    </ngx-select>
                    </div>
                   
                  </div>
                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  
                  <div class="form-group">
                    <label class="customlabel">From Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="From Date" id="fromdate"
                      [formControl]="fromdate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                  </div>

                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">
                  
                  <div class="form-group">
                    <label class="customlabel">To Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="To Date" id="todate"
                      [formControl]="todate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                  </div>
                  <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                    Date</span>
                </div>
               
                <div class="col-md-3  mt-4">
                 
                  <div class="form-group">
                    <label class="customlabel">Customer ID</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Customer ID" id="CustomerId"
                      [formControl]="CustomerId">
                  </div>
                </div>
                <div class="col-md-3  mt-4">
                  
                  <div class="form-group">
                    <label class="customlabel">Company Name</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Company Name" id="CompanyName"
                      [formControl]="CompanyName">
                  </div>
                </div>

                <div class="col-md-3  mt-4">
                 
                  <div class="form-group">
                    <label class="customlabel">Name</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Name" id="Name"
                      [formControl]="Name">
                  </div>
                </div>
                <div class="col-md-3  mt-4">
                 
                  <div class="form-group">
                    <label class="customlabel">Mobile No.</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="MobileNo" id="Mobile No" (keypress)="numberOnly($event)"
                      [formControl]="MobileNo">
                  </div>
                </div>
              </div>
            </form>
            <!-- filtering ends -->
          </div>
          <div  class="col-md-12 text-right">
            <div style="display: inline-block;  margin-right:5px;" class="text-right mt-3" *ngIf="!isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" (click)="selectedaterange()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>

            <div style="display: inline-block;  margin-right:5px;" class="text-right mt-3" *ngIf="isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive" (click)="search()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>

            <div style="display: inline-block;  margin-right:5px;" class="text-right">
              <button type="reset" class="dash-btns" (click)="resetForm()"
                matTooltip="New Sale Transaction">Reset</button>
            </div>

            <!-- <a href="" style="color: #d40055;">Clear</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
          <ngx-datatable-column name="Action" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewPayOutContact',{Id: row.Id}]" data-toggle="tooltip"
                data-placement="top" title="View" *ngIf="viewpayout">
                <img src="./assets/ViewDetails.svg">
              </a>
                <a class="edit btn btn-demo" (click)="viewpayoutdetails(row.Id,row.MerchantKeyId)" data-bs-toggle="modal" data-bs-target="#myModal2" data-bs-placement="top" title="Basic View">
                    <em class="fa-1x mr-2 fas fa-eye"></em>
                  </a>
              <a class=" edit pl-3 d-inline" [routerLink]="['/PayOut/EditPayOutContact',{Id: row.Id}]"
                data-toggle="tooltip" data-placement="top" title="Edit" *ngIf="editpayout"> <em class="fas mr-2 fa-edit"></em>
              </a>
              <span  *ngIf="row.IsDelete==1 && viewpayout">
              <a class="edit pl-3 d-inline" [routerLink]="['/PayOut/DeletePayoutContacts',{Id: row.Id}]"
                data-toggle="tooltip" data-placement="top" title="Delete" *ngIf="deletepayout">
                <em class="far fa-trash-alt mr-2"></em>
              </a>
              </span>

              <a class="edit pl-3 d-inline" [routerLink]="['/PayOut/AddBeneficiaries',{Id: row.PayoutCustomerkeyId}]"
                data-toggle="tooltip" data-placement="top" title="Add Beneficiary" *ngIf="Addbenificiaries && hidebeneficiary">
                <em class="fa fa-plus mr-2"></em>
              </a>

              <!-- <a class="edit pl-1 d-inline"
              [routerLink]="['/PayOut/ViewBeneficiaries',{PayoutCustomerkeyId: row.PayoutCustomerkeyId}]"
              data-toggle="tooltip" data-placement="top" title="Create Transaction">
              <i class="fas fa-exchange-alt mr-2"></i>
          </a> -->
              <!-- [routerLink]="['/PayOut/ViewBeneficiaries',{PayoutCustomerkeyId: row.PayoutCustomerkeyId}]" -->
              <a class="edit pl-3 d-inline" (click)="initiattransaction(row.PayoutCustomerkeyId)" data-toggle="tooltip"
                data-placement="top" title="Create Transaction" *ngIf="createTransaction">
                <em class="fas fa-exchange-alt mr-2"></em>
              </a>





            </ng-template>
          </ngx-datatable-column>

          <!-- [width]="200" -->
          <ngx-datatable-column name="Payout Customer keyId" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayoutCustomerkeyId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Customer Id">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.CustomerId}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Company Name">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.CompanyName}}</div>
            </ng-template>

          </ngx-datatable-column>
          <ngx-datatable-column name="Name">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.FirstName}}
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column name="City">
          <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.Phone}}</div></ng-template>
        </ngx-datatable-column> -->

          <ngx-datatable-column name="Mobile No">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.MobileNo}}</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Email">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.Email}}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Date Time">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDatetime | date:'d/M/yy, h:mm a' }}</div>
            </ng-template>
          </ngx-datatable-column>



        </ngx-datatable>
      </div>
    </div>
  </section>
</div>




<!-- Tour strats -->

<div class="" *ngIf="tourDiv">
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <div class="pt-5 text-right">
          <button class="btn btn-warning" (click)="SkipTour()">Skip <i class="fas fa-step-forward"></i></button>

        </div>
      </div>
    </div>
  </div>
  <div class="" *ngIf="PayoutStep1">
    <div class="one">
      <div class="row  tourstep">
        <div class="col-md-6  d-none d-sm-none d-md-block">
          <img class="w-100 mt-3" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/payout.png"
            style="width: 350px ;">
        </div>
        <div class="col-md-6">
          <div class="mt-5  py-3">
            <img src="assets/img/logo.png" style="width: 100px;">
          </div>
          <h3 style="font-size: 40px; line-height: 48px;
                    margin: 16px 0 8px 0;
                    font-weight: bold;
                    color: #0d2366;">PayOuts</h3>
          <h5 class="padding-b-xs" style="font-size: 15px; line-height: 25px; color: #969aa1;">Send payments instantly
            and securely to bank accounts. UPI IDs and wallets via APIs, Dashboards and file uploads.
          </h5>

          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                    bottom: 17px;
                    right: 64px;">
            <button class="box-button" (click)="Nextstep() ">Next</button>

          </div>
          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                   bottom: 17px;
                    bottom: 25px;
                    right: 150px;">
            <input class="formcontrol-user form-control" class="d-inline mb-0 mr-2" type="checkbox"
              (click)="ShowMeAgain()" />
            <p class="d-inline mb-0 text-primary">Do not show me again</p>

          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="" *ngIf="PayoutStep2">
    <div class="one">
      <div class="row  tourstep tourstep1">
        <div class="col-md-12">
          <h3 style="font-size: 25px; line-height: 48px;margin: 16px 0 8px 0; font-weight: bold;
                  color: #0067ef94;">Payouts- The power on your side!</h3>

          <div class="row p-2">
            <div class="col-md-4">
              <div class="Feature">
                <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/bank-icon.png">
                <div class="Feature-title">More than just bank transfers</div>
                <p class="Feature-desc">Send payouts to any Bank account UPI- ID or wallets. Verify bank accounts in
                  real time.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="Feature">
                <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/support-icon.png">
                <div class="Feature-title">Works on holidays</div>
                <p class="Feature-desc">Payouts work 24x7. Money disbursal and transfer even when banks are not working.
                </p>
              </div>
            </div>
            <div class="col-md-4 padding-b-xs">
              <div class="Feature">
                <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/upload-icon.png">
                <div class="Feature-title">Simpler file uploads than banks</div>
                <p class="Feature-desc">No more tedious file uploads. Bulk payouts are easy now with single file upload.
                </p>
              </div>
            </div>



          </div>
          <div class="pt-5 text-right" style="vertical-align: bottom;  position: absolute;
                bottom: 24px; right: 180px; font-size: 18px; cursor: pointer; color: #006ff0;">
            <a class="box-a" (click)="backSubmit()">Back</a>

          </div>
          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                bottom: 17px;
                right: 64px;">
            <button class="box-button" (click)="GetStarted() ">Get Started</button>

          </div>
        </div>

      </div>
    </div>

  </div>

  <div class="" *ngIf="PayoutStep4">
    <div class="one">
      <div class="row  tourstep">
        <div class="col-md-6">
          <img class="w-100 mt-3" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/payout4.png"
            style="width: 350px;">
        </div>
        <div class="col-md-6">
          <div class="mt-5  py-3">
            <img src="assets/img/logo.png" style="width: 100px;">
          </div>
          <h3 style="font-size: 40px; line-height: 48px;
                margin: 16px 0 8px 0;
                font-weight: bold;
                color: #0d2366;">Simpler file uploads than banks</h3>
          <h5 style="font-size: 15px; line-height: 25px;  color: #969aa1;">No more tedious file uploads. Bulk payouts
            are easy now with single file upload.</h5>
          <div class="pt-5 text-right" style="vertical-align: bottom;  position: absolute;
                bottom: 24px; right: 180px; font-size: 18px; cursor: pointer; color: #006ff0;">
            <a class="box-a" (click)="backSubmit2()">Back</a>

          </div>
          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                bottom: 17px;
                right: 64px;">
            <button class="box-button" (click)="GetStarted() ">Get Started</button>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- tour Ends -->

<div class="modal right fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h4 class="modal-title" id="myModalLabel2">View Payout Contact</h4> 
      </div>

      <div class="modal-body">
        <div class="row mt-3 mb-3">
          <div class="col-md-12">
            <div class="row  my-3">
                <div class="col-md-6">
                    <label>Payout CustomerkeyId </label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> {{ViewPayoutCustomerkeyId}}</div>
                 

                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label> Customer AccountId
                    </label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> {{ViewCustomerAccountId}}</div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>Customer Id</label> </div>

                <div class="col-md-6 view-text "> {{ViewCustomerId}}
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>Company Name</label> </div>

                <div class="col-md-6 view-text  ">{{ViewCompanyName}} </div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>FirstName </label>
                </div>
                <div class="col-md-6 view-text ">{{ViewFirstName}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>LastName </label>
                </div>
                <div class="col-md-6 view-text">{{ViewLastName}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Address </label>
                </div>
                <div class="col-md-6 view-text">{{ViewAddress}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>City</label>
                </div>
                <div class="col-md-6 view-text">{{ViewCity}}
                </div>
            </div>



            <div class="row my-3">

                <div class="col-md-6">
                    <label>State</label>
                </div>

                <div class="col-md-6 view-text">{{ViewState}}</div>
            </div>
           
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Country </label>
                </div>

                <div class="col-md-6 view-text">{{ViewCountry}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>ZipCode </label>
                </div>

                <div class="col-md-6 view-text">{{ViewZipCode}}</div>
            </div>

            




        </div>
        <div class="col-md-12">
            <div class="row my-3">

                <div class="col-md-6">
                    <label>MobileNo </label>
                </div>

                <div class="col-md-6 view-text">{{ViewMobileNo}}</div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label>MobileNo2</label>
                </div>

                <div class="col-md-6 view-text robot"> {{ViewMobileNo2}}</div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label>Email </label>
                </div>

                <div class="col-md-6 view-text">{{ViewEmail}} </div>

            </div>

            <div class="row my-3">

              <div class="col-md-6">
                  <label>Email2 </label>
              </div>

              <div class="col-md-6 view-text">{{ViewEmail2}} </div>

          </div>

            <div class="row my-3">

                <div class="col-md-6">
                    <label>DateTime </label>
                </div>

                <div class="col-md-6 view-text">{{ViewUpdatedDatetime | date:'d/M/yy, h:mm a'}}</div>

            </div>
           
            <div class="row">
              <div class="col-md-12  p-0">
                <div class="border-bottom mt-3">
                  <a class="accordion" (click)="toggleAccordian($event)">UserDefined </a>
                  <div class="panel text-left mt-3" hide="!item.isActive">
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined1 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined1}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined2 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined2}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined3 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined3}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined4 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined4}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined5 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined5}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined6 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined6}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined7 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined7}}</div>
                    </div>
                    <div class="row p-1 my-3">

                      <div class="col-5"><label> UserDefined8 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined8}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined9 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined9}}</div>
                    </div>
                    <div class="row  p-1 my-3">

                      <div class="col-5"><label> UserDefined10 </label> </div>

                      <div class="col-7 p-0 view-text"> {{ViewUserDefined10}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
          
           
           
           
         

          
          
         
        </div>
        </div>
      </div>

    </div><!-- modal-content -->
  </div><!-- modal-dialog -->
</div><!-- modal -->

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content card-1 p-1">
      <div class="modal-header" style="border-bottom:none">

        <button type="button" class="close blue1-t font-16" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">Skip</span>
        </button>
      </div>
      <div class="modal-body" style="border-bottom:none">
        <div class="row ">
          <div class="mx-auto mb-2">
            <img src="assets/img/new/tour.svg" alt="" height="150">
          </div>
          <div class="col-md-12 text-center">
            <div *ngIf="step1">
              <h4 class="gary-t font-20 pt-3 ">PayOuts</h4>
              <div class="lite-gray-t py-2">
                <p>Send payments instantly and securely to bank accounts. UPI IDs and wallets via APIs, Dashboards and
                  file uploads.
                </p>
              </div>
              <div class=" text-center">
                <button class="btn blue-btn" (click)="next2()">Next</button>
              </div>
            </div>
            <div *ngIf="step2">
              <h4 class="gary-t font-20 pt-3 ">Payouts- The power on your side!</h4>


              <div class="col-md-12">
                <div class="">
                  <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/bank-icon.png">
                  <div class="Feature-title">More than just bank transfers</div>
                  <p class="lite-gray-t ">Send payouts to any Bank account UPI- ID or wallets. Verify bank accounts in
                    real time.</p>
                </div>
              </div>



              <div class=" text-center">
                <button class="btn blue-btn" (click)="next3()">Next</button>
                <a type="a" class="lite-gra-t font-16 d-block mt-2" (click)="back1()" style="color: #262626;">Back</a>
              </div>
            </div>
            <div *ngIf="step3">
              <h4 class="gary-t font-20 pt-3 ">Payouts- The power on your side!</h4>
              <div class="col-md-12">
                <div class="">
                  <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/support-icon.png">
                  <div class="Feature-title">Works on holidays</div>
                  <p class="lite-gray-t ">Payouts work 24x7. Money disbursal and transfer even when banks are not
                    working.</p>
                </div>
              </div>
              <div class=" text-center">
                <button class="btn blue-btn" (click)="next4()">Next</button>
                <a type="a" class="lite-gray-t font-16 d-block mt-2" (click)="back2()" style="color: #262626;">Back</a>
              </div>
            </div>
            <div *ngIf="step4">
              <h4 class="gary-t font-20 pt-3 ">Payouts- The power on your side!</h4>
              <div class="col-md-12">
                <div class="">
                  <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/upload-icon.png">
                  <div class="Feature-title">Simpler file uploads than banks</div>
                  <p class="lite-gray-t ">No more tedious file uploads. Bulk payouts are easy now with single file
                    upload.</p>
                </div>
              </div>
              <div class=" text-center">
                <button class="btn blue-btn" data-bs-dismiss="modal" aria-label="Close" type="button">Get Started</button>
                <a type="a" class="lite-gra-t font-16 d-block mt-2" (click)="back3()" style="color: #262626;">Back</a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>